'use strict';

var _Translator = require('./Translator');

var _Translator2 = _interopRequireDefault(_Translator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var translator = new _Translator2.default();

var api = {
    translator: translator,
    Translator: _Translator2.default,
    translate: translator.translate.bind(translator)
};

module.exports = api;